import { WppSkeleton } from '@wppopen/components-library-react'

interface ButtonSkeletonProps {
  width?: number
}

const ButtonSkeleton = ({ width }: ButtonSkeletonProps) => {
  return <WppSkeleton variant="rectangle" width={width || 75} height={40} data-testid="button-skeleton" />
}

export default ButtonSkeleton
